import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X, Phone, CalendarDays } from "lucide-react";
import samranLogo from "@/assets/samran-logo-light.png";
import BookConsultationDialog from "@/components/BookConsultationDialog";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: "About Us", href: "/about" },
    { label: "Buy A Farm", href: "/buy-a-farm" },
    { label: "Sell A Farm", href: "/sell-a-farm" },
    { label: "Farm Management", href: "/farm-management" },
  ];

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled 
          ? 'bg-foreground/95 backdrop-blur-md shadow-lg' 
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center">
            <img 
              src={samranLogo} 
              alt="Gurbir Samran Farm & Land Real Estate" 
              className="h-14 md:h-16 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-sm text-white/90 hover:text-primary transition-colors duration-300 tracking-wider font-medium"
              >
                {item.label}
              </a>
            ))}
            <BookConsultationDialog
              trigger={
                <Button variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold gap-2">
                  <CalendarDays className="h-4 w-4" />
                  Book Consultation
                </Button>
              }
            />
            <a href="tel:+15598719051">
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90 font-semibold gap-2">
                <Phone className="h-4 w-4" />
                (559) 871-9051
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          >
            {isMenuOpen ? (
              <X className="h-6 w-6 text-white" />
            ) : (
              <Menu className="h-6 w-6 text-white" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-6 pb-6 border-t border-white/20 pt-6">
            <div className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="text-white/90 hover:text-primary transition-colors tracking-wider font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <BookConsultationDialog
                trigger={
                  <Button variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold w-full gap-2">
                    <CalendarDays className="h-4 w-4" />
                    Book Consultation
                  </Button>
                }
              />
              <a href="tel:+15598719051">
                <Button className="bg-primary text-primary-foreground hover:bg-primary/90 font-semibold w-full gap-2 mt-2">
                  <Phone className="h-4 w-4" />
                  (559) 871-9051
                </Button>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
